import * as types from './types';

const INITIAL_STATE = {
  savedExports: [],
  loading: true,
  error: null,
  deleteSuccessful: false,
  assignedSites: [],
  assignedBedsCodes: [],
  usedFileNames: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.EXPORTS_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case types.GET_SAVED_EXPORTS:
      let sites = [];
      payload.forEach((x) => {
        sites.push(...x.SiteIds);
      });
      return {
        ...state,
        savedExports: payload,
        assignedBedsCodes: payload.map((x) => x.BedsCode),
        assignedSites: sites,
        usedFileNames: payload.map((x) => x.FileName),
      };
    case types.GET_SAVED_EXPORTS_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.SAVED_EXPORTS_CLEAR_ERROR:
      return { ...state, error: null };
    case types.SAVED_EXPORT_DELETE_SUCCESSFUL:
      return { ...state, deleteSuccessful: payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/state/exportlist/reducer.js